import Endpoints from '@/constants/endpoints';

import Constants from '@/constants/constants';

import dayjs from 'dayjs';
import 'dayjs/locale/es';

import $http from '@/core/services/http.service';

import { TimetablesInterface } from '@/shared/interfaces/timetables.interface';
import { Convocation } from '@/manager/convocation/convocation.model';
import { TypeOfProduct } from '@/manager/product/models/product.model';


export { TypeOfProduct };

export class ConvocationService {
    public static downloadCsv(idConvocation: string, filters: any): void {
        const baseUrl = process.env.VUE_APP_BASE_URI_API;
        const baseEndpoint = `${Endpoints.convocation}`;
        let params = `?limit=${Constants.downloadCsvLimit}`;
        for (const key in filters) {
            if (filters.hasOwnProperty(key)) {
                const value = filters[key];
                if (value) {
                    params += `&${key}=${value}`;
                }
            }
        }

        const url = `${baseUrl}${baseEndpoint}${idConvocation}/participant/csv/${params}`;
        window.location.href = url;
    }

    public static downloadCsvByLocalUrl(url: any): void {
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = url;
        anchor.target = "_blank";
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    }

    public static uploadCsv(): Promise<File> {
        return new Promise((resolve) => {

            const input = document.createElement('input');
            input.type = "file";
            input.accept = ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            const container = document.getElementById('app');
            container && container.appendChild(input);

            input.addEventListener('change', function (e) {
                const files = (<HTMLInputElement>e.target).files

                if (files === null || !files.length) {
                    return null;
                }
                return resolve((files[0] as any) as File)

            }
            );
            setTimeout(function () {
                input.click()
            }, 200);
        });
    }

    public static formatDates(timetables: TimetablesInterface[], options: any = {}): string {
        options = {
            includeYear: true,
            monthShort: false,
            ...options,
        };
        let text = 'Sin fecha';
        if (timetables) {
            const days: any[] = [];
            const months: any[] = [];
            let year: string = '';
            const now = dayjs();
            timetables.forEach(
                (timetable: any) => {
                    const dayjsDate = dayjs(timetable.date, { locale: 'es' });
                    const day = dayjsDate.format('D');
                    const month = dayjsDate.format('MMMM').toLowerCase();
                    const monthShort = dayjsDate.format('MMM').toLowerCase();

                    year = dayjsDate.format('YYYY');
                    const findedMonth = months.find((m: any) => m.month === month);
                    const monthExists = months.indexOf(findedMonth);
                    if (monthExists !== -1) {
                        months[monthExists].numDays++;
                    } else {
                        months.push({ month, monthShort, numDays: 1 });
                    }
                    days.push({ day, month });
                },
            );
            let formattedDate = '';
            let monthIndex = 0;
            months.forEach(
                (month: any) => {
                    monthIndex++;
                    let dayIndex = 0;
                    days.forEach(
                        (obj) => {
                            if (obj.month === month.month) {
                                dayIndex++;
                                if (dayIndex === month.numDays && month.numDays > 1) {
                                    formattedDate += ` y ${obj.day} `;
                                } else if (dayIndex === 1) {
                                    formattedDate += `${obj.day}`;
                                } else {
                                    formattedDate += `, ${obj.day}`;
                                }
                            }
                        },
                    );
                    if (options.monthShort || months.length > 1) {
                        formattedDate += ` de ${month.monthShort}`;
                    } else {
                        formattedDate += ` de ${month.month}`;
                    }
                    if (months.length > 1 && monthIndex < months.length) {
                        formattedDate += ` y `;
                    }
                },
            );
            if (options.includeYear) {
                formattedDate += ` de ${year}`;
            }
            text = formattedDate;
        }
        return text;
    }

    public static mailToFilteredUsers(list: any[]) {
        if (list !== undefined) {
            const emailList = list.map(
                (participant: any) => {
                    return participant.email;
                },
            );
            if (emailList.length > 0) {
                window.location.href = `mailto:?bcc=${emailList.join(',')}`;
            }
        }
    }

    public static participantInscription(convocationId: string, payload: any) {
        return $http.post(Endpoints.convocationInscription(convocationId), payload);
    }

    public static convocationIsProductType(convocation: Convocation, typeOfProduct: TypeOfProduct) {
        return (convocation.product as any).typeOfProduct === typeOfProduct;
    }

    public static convocationFirstDayKpi(convocationId: string) {
        return $http.get(Endpoints.convocationKpi(convocationId));
    }

}
